import when from 'when'

export default class GetVid {
    constructor(vid, parent, width, height) {
        this.vid = vid
        this.parent = parent
        this.width = width
        this.height = height
        // this.isMobile = Bowser.getParser(window.navigator.userAgent).parsedResult.platform.type !== 'desktop'

    }

    init(){ 
        this.defer = when.defer()
        this.setVid()
        return this.defer.promise
    }

    setVid(){
        this.videoObj =   this.vid;
        this.videoObj.style.width = document.width + 'px';
        this.videoObj.style.height = document.height + 'px';
        this.videoObj.setAttribute('autoplay', '');
        this.videoObj.setAttribute('muted', '');
        this.videoObj.setAttribute('playsinline', '');
    
        navigator.mediaDevices.getUserMedia({
            audio: false,
            video: {
                width: this.width,
                height: this.height,
                require: ['width', 'height'],
                facingMode: 'user'
            },
        }).then((mediaStream) => {
            this.videoObj.srcObject = mediaStream
            this.videoObj.onloadedmetadata = () => {
                this.videoObj.play();
                setTimeout(() => {
                    this.defer.resolve()
                }, 200)
            };
        }).catch((err) => {
            console.log(err)
        } )
    
    }
}